<template>
  <div class="card border-0 bg-transparent">
    <div class="card-body p-0">
      <div class="d-flex align-items-end mb-4">
        <familienversicherung_icon class="me-3"></familienversicherung_icon>
        <h5 class="font-xl-links-bold mb-0">Versicherungsnehmer</h5>
      </div>

      <div class="row g-3">
        <!-- Row 1: Anrede + Titel -->
        <div class="col-md-6">
          <SelectField
            :id="`vpAnrede${item.id}`"
            label="Anrede *"
            v-model="localAnrede"
            :options="anredeOptions"
            placeholder="Bitte auswählen"
          />
        </div>

        <div class="col-md-6">
          <SelectField
            :id="`vpTitel${item.id}`"
            label="Akademischer Titel"
            v-model="localTitel"
            :options="titelOptions"
            placeholder="Bitte auswählen"
          />
        </div>

        <!-- Row 2: Vorname + Nachname -->
        <div class="col-md-6">
          <TextField
            :id="`vpVorname${item.id}`"
            label="Vorname *"
            v-model="localVorname"
          />
        </div>

        <div class="col-md-6">
          <TextField
            :id="`vpNachname${item.id}`"
            label="Nachname *"
            v-model="localNachname"
          />
        </div>

        <div class="col-md-6" v-if="isVigoselect">
          <TextField
            :id="`vpAoknummer${item.id}`"
            label="AOK Versicherten-Nr. *"
            v-model="localAoknummer"
          />
        </div>
        
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import SelectField from '@/fields/SelectField.vue';
import TextField from '@/fields/TextField.vue';
import familienversicherung_icon from '@/components/icons/familienversicherung_icon.vue';
import { useMainStore } from '@/stores/useMainStore.js';

const mainStore = useMainStore();

const isVigoselect = computed(() => mainStore.kanal === 'vigoselect');


const props = defineProps({
  item: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update:item']);

// Optionen für Select-Felder
const anredeOptions = [
  { value: 'Herr', text: 'Herr' },
  { value: 'Frau', text: 'Frau' }
];

const titelOptions = [
  { value: '', text: '--' },
  { value: 'Dr.', text: 'Dr.' },
  { value: 'Prof.', text: 'Prof.' },
  { value: 'Prof. Dr.', text: 'Prof. Dr.' }
];

// Lokale reaktive Werte mit zwei-Wege-Bindung
const localAnrede = computed({
  get: () => props.item.anrede || '',
  set: (value) => emitUpdate('anrede', value)
});

const localTitel = computed({
  get: () => props.item.titel || '',
  set: (value) => emitUpdate('titel', value)
});

const localVorname = computed({
  get: () => props.item.vorname || '',
  set: (value) => emitUpdate('vorname', value)
});

const localNachname = computed({
  get: () => props.item.nachname || '',
  set: (value) => emitUpdate('nachname', value)
});

const localAoknummer = computed({
  get: () => props.item.aoknummer || '',
  set: (value) => emitUpdate('aoknummer', value)
});

// Emittiert Update für einzelnes Feld
function emitUpdate(field, value) {
  const updatedItem = { ...props.item, [field]: value };
  emit('update:item', updatedItem);
}
</script>

<style scoped>
.font-xl-links-bold {
  font-weight: 700;
}
</style>
